import React from 'react'
import axios from 'axios'
import { businessApiURL, getCountryCode, getLanguageCode, getToken } from '../..'

export async function getCustomerDetails() {
  try {
    const res = await axios.get(
      `${businessApiURL}/api/secure/bc/details?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
